import { Label } from '@mairistem/composants';
import { Combobox } from '@mairistem/finances-utils';
import React from 'react';
import BordereauStateFactory from '../../../../classes/bordereaux/state/BordereauStateFactory';

import type BordereauStateType from '../../../../constants/liquidation/bordereaux/BordereauStateType';
import './Bordereau.css';

interface FiltresBordereauProps {
	onChange: (bordereauStateType: number) => void;
	visibleStates: Set<BordereauStateType>;
}
const FiltresBordereauState = ({
	onChange,
	visibleStates,
}: FiltresBordereauProps) => {
	if (visibleStates.size === 0) {
		return null;
	}

	return (
		<Combobox
			options={BordereauStateFactory.getAllStates()
				.filter((state) => visibleStates.has(state.state))
				.map((state) => ({
					key: state.step,
					value: state.step,
					'data-testid': `filtreBordereauStateComboboxOption${state.step}`,
					text: (
						<Label
							horizontal
							style={{
								backgroundColor: state.color,
							}}
							size="medium"
							className="bordereau-label"
						>
							{state.libelle}
						</Label>
					),
				}))}
			placeholder="Tous les états"
			clearable
			onChange={(_e, { value }: { value: number }) => onChange(value)}
			data-testid="filtreBordereauStateCombobox"
		/>
	);
};

export default FiltresBordereauState;
